import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _NoveltyAccount, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { CardTaps } from "../../../theme/Component/CardTaps";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { HandlerInfoProcess } from "../../../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import { ListMenu } from "../../../theme/Component/ListMenu";

export const NoveltyAccount = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_NoveltyAccount);
    const [indexTap, setIndexTap] = useState(0);;

    const modalHistory = useModal("Historial del procedimiento", MODAL_XL)

    useEffect(() => {
        getLista();
    }, [indexTap])

    const returnState = () => {
        if (indexTap == 0) {
            return 100;
        }
        if (indexTap == 1) {
            return 101;
        }
        if (indexTap == 2) {
            return 102;
        }
    }

    const getLista = () => {
        const props = {
            State: returnState()
        }

        instance.getNoveltyAccountCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                // paginator.setPages(resp.NumberOfPages);
                // paginator.setRecords(resp.NumberOfPages * 15);

                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Solicitudes");
        });
    };

    const head = [
        { title: 'ID', property: 'IDNoveltyAccount', visible: true },
        { title: 'Solicitud', property: 'DescriptionRequest', visible: true },
        { title: 'Respuesta', property: 'DescriptionResponse', visible: true },
        { title: 'Fecha de Soliciud', property: 'ApplicationDate', visible: true },
        // { title: 'Estado', property: 'State', visible: true },
    ];

    let taps = [
        { id: 0, name: 'Solicitadas', disable: false },
        { id: 1, name: 'Aprobadas', disable: false },
        { id: 2, name: 'Rechazadas', disable: false }
    ];

    const listaBotones = () => {
        const botones = [
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: true, evento: () => { modalHistory.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Lista de Solicitudes">
            <div className="row">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    <div className="col-md-12">
                        <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                        <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                            <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureIMP} />
                        </Modal>

                    </div>
                </CardTaps>
            </div>
        </BasicPage>
    )
}